import { EventEmitter } from "events"
import dispatcher from "../dispatcher"

class PunchStore extends EventEmitter {
    constructor() {
        super()
        this.setMaxListeners(0)
    }
    
    handleActions(action) {
        switch (action.type) {
            case "FAILED_PATCH_PUNCH": {
                this.emit("faled_patch_punch")
                break
            }
        }
    }
}

const punchStore = new PunchStore()
dispatcher.register(punchStore.handleActions.bind(punchStore))
export default punchStore
